import { createSvgIcon } from "@mui/material/utils";

export default createSvgIcon(
  <path
    d="M8.4652 20.485L16.9502 12L8.4652 3.51498L7.0502 4.92898L14.1222 12L7.0502 19.071L8.4652 20.485Z"
    xmlns="http://www.w3.org/2000/svg"
  />,
  "ChevronBigRight"
);
